enum BillingMethodType {
  OTHERS = 'OTHERS',
  PIX = 'PIX',
}

export default BillingMethodType;
